import { Box, Button, Typography } from "@mui/material";
import styled from "styled-components";

export const Container = styled(Box)`
    display: flex;
    flex-direction: column;
    padding: 20px 30px !important;
    background: white;
    gap: 20px;
    padding: 0px 20px;
    justify-content: center;
    align-items: center;
`;

export const BoxContainer = styled(Box)`
    display:flex;
    flex-direction:column;
    gap=20px;
`;

export const CatBtn = styled(Button)`
    border-radius: 5px;
    padding: 2px;
    color: ${(props: any): any => props.text} !important;
    background: ${(props: any): any => props.bg} !important;
`;

export const KeyValueText = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
`;
export const KeyTxt = styled(Typography)`
    font-size: 12px !important;
    color: #4F4F4F;
`;
export const ValueTxt = styled(Typography)`
    font-size: 12px !important;
    color: black;
    text-decoration: ${(props: any): any => props?.isSame ? 'line-through red' : 'none'};
`;
export const SmallValueTxt = styled(Typography)`
    font-size: 10px !important;
    color: black;
    text-decoration: ${(props: any): any => props?.isSame ? 'line-through red' : 'none'};
`;
export const MediumValueTxt = styled(Typography)`
    font-size: 12px !important;
    color: black;
    text-decoration: ${(props: any): any => props?.isSame ? 'line-through red' : 'none'};
`;
